import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" action: the intent the page dispatches for the saga to act on.
 * Kept out of the slice's reducers: it triggers a side effect, not a state
 * transition (the saga owns the resulting `load*` transitions).
 */

/** Fetch the fundraisings listing (dispatched on mount). */
export const fundraisingsRequested = createAction('fundraisings/fundraisingsRequested');
